import { useQueries } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { userAtom } from "../utils/store";
import {
  getInstitutionByApplicantId,
  getWorkHistoryByApplicantId,
  getUploadNyscByApplicantId,
  getPersonalInfoByApplicantId,
  getQualificationByApplicantId,
} from "../utils/request";

export const useApplicantData = () => {
  const user = useAtomValue(userAtom);

  const queries = useQueries({
    queries: [
      {
        queryKey: ["get-institution", user?.applicantId],
        queryFn: () => getInstitutionByApplicantId(user?.applicantId ?? ""),
        enabled: !!user?.applicantId,
      },
      {
        queryKey: ["get-work-history", user?.applicantId],
        queryFn: () => getWorkHistoryByApplicantId(user?.applicantId ?? ""),
        enabled: !!user?.applicantId,
      },
      {
        queryKey: ["get-nysc-upload", user?.applicantId],
        queryFn: () => getUploadNyscByApplicantId(user?.applicantId ?? ""),
        enabled: !!user?.applicantId,
      },
      {
        queryKey: ["get-personal-info-id", user?.applicantId],
        queryFn: () => getPersonalInfoByApplicantId(user?.applicantId ?? ""),
        enabled: !!user?.applicantId,
      },
      {
        queryKey: ["get-all-qualification", user?.applicantId],
        queryFn: () => getQualificationByApplicantId(user?.applicantId ?? ""),
        enabled: !!user?.applicantId,
      },
    ],
  });

  const [
    institutionQuery,
    workHistoryQuery,
    nyscUploadQuery,
    personalInfoQuery,
    qualificationQuery,
  ] = queries;

  const personalInfo = personalInfoQuery?.data?.data as PersonalInfo;
  const institutions = institutionQuery?.data?.data as InstitutionData[];
  const workHistory = workHistoryQuery?.data?.data as WorkHistoryData[];
  const nyscUpload = nyscUploadQuery?.data?.data as NyscUpload;
  const qualifications = qualificationQuery?.data?.data as Qualification[];

  const isLoading =
    institutionQuery?.isLoading ||
    workHistoryQuery?.isLoading ||
    nyscUploadQuery?.isLoading ||
    personalInfoQuery?.isLoading ||
    qualificationQuery?.isLoading;

  const isError =
    institutionQuery?.isError ||
    workHistoryQuery?.isError ||
    nyscUploadQuery?.isError ||
    personalInfoQuery?.isError ||
    qualificationQuery?.isError;

  return {
    personalInfo,
    institutions,
    workHistory,
    nyscUpload,
    qualifications,
    isLoading,
    isError,
  };
};
